"use client";
import { useEffect, useState, useRef, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from 'react-router-dom'
import { capitalizeEachWord } from '@utils/utils';
import { PROPERTY_CATEGORY, PROPERTY_CATEGORY_COLORS } from '@constant/constants'
import ReactGA from "react-ga4";
import moment from "moment";
import ReactPaginate from "react-paginate";
import { IoLocationOutline } from '@assets/Icons'
import ImagesData from '@assets/ImagesData'
import SearchBar from '@components/searchBar/SearchBar';
import CommonSlider from '@shared/slick/CommonSlider';
import {
    getRroomPropertyAction,
    propertySeletor,
    setFilter,
    setSearch,
    setLoading,
    clearPropertyState
} from "@store/slices/propertySlice";
import { authenticationSeletor } from "@store/slices/authenticationSlice";
import { baseImgUrl } from "@api/client/api";
import SklHotelCard from "@shared/skeleton/SklHotelCard";
import services from '@api/services';
import { FaFilter } from "react-icons/fa";
import { LuFilter } from "react-icons/lu";
import { IoMdClose } from "react-icons/io";

const reviewKeynumber = {
    1: "Very Poor",
    2: "Poor",
    3: "Good",
    4: "Very Good",
    5: "Excellent",
};

const traveller = [
    {
        name: "Hourly",
        enum: 8,
    },
    // {
    //     name: "Short-Stays",
    //     enum: 1,
    // },
    {
        name: "Business Travel",
        enum: 2,
    },
    {
        name: "Couple Friendly",
        enum: 7,
    },
    {
        name: "Family Vacation",
        enum: 3,
    },
    {
        name: "Group Travel",
        enum: 5,
    },

    {
        name: "Solo Travel",
        enum: 6,
    },

];

const HotelsInLucknow = () => {

    const dispatch = useDispatch();
    const isFetchingRef = useRef(false);
    const sidebarRef = useRef();
    // const path = usePathname();
    const navigate = useNavigate();

    const { userDetail } = useSelector(authenticationSeletor);
    const { rRoomProperty, propertyCount, filterValues, searchVal, loading } = useSelector(propertySeletor);

    const [propertyList, setPropertyList] = useState([]);
    const [propertyCategoryData, setPropertyCategoryData] = useState([]);
    const [categoryData, setCategoryData] = useState([]);
    const [tableData, setTableData] = useState([]);
    const [avrageReview, setAvrageReview] = useState({});
    const [sortValue, setSortValue] = useState(0);
    const [localities, setLocalities] = useState([]);
    const [page, setPage] = useState(1);

    const itemsPerPage = 10;
    const totalPages = propertyCount / itemsPerPage;
    const cityName = sessionStorage.getItem("cityName");
    // const currentCity = path.split('-')?.pop();

    useEffect(() => {
        ReactGA.send({ hitType: "pageview", page: "hotel_listing" });
        setPropertyList(rRoomProperty);
    }, [rRoomProperty]);

    useEffect(() => {
        let byPrice =
            sortValue == 1
                ? "order_by=price&order_direction=desc"
                : sortValue == 2
                    ? "order_by=price&order_direction=asc"
                    : sortValue == 3
                        ? "order_by=rating&order_direction=desc"
                        : "order_direction=asc";
        let getFilterValuesData = { ...filterValues };
        if (getFilterValuesData?.latlongFilter) {
            const { lat, long } = getFilterValuesData?.latlongFilter;
            if (lat && long) {
                dispatch(
                    getRroomPropertyAction(`?order_direction=asc&lat=${lat}&long=${long}`)

                );
                return;
            }
        }
        let choice = getFilterValuesData?.travellerChoice?.length
            ? `&traveller_choice=${getFilterValuesData?.travellerChoice?.toString()}`
            : "";
        let locality =
            getFilterValuesData?.localityFilter?.length != 0
                ? `&pin_code=${getFilterValuesData.localityFilter}`
                : "";

        if (
            locality.length ||
            sortValue ||
            getFilterValuesData?.propertyCategoryFilter?.length ||
            getFilterValuesData?.roomCategoryFilter?.length ||
            getFilterValuesData?.travellerChoice?.length
        ) {
            let propertyType =
                getFilterValuesData?.propertyCategoryFilter?.toString();
            let roomType = getFilterValuesData?.roomCategoryFilter?.toString();
            dispatch(
                getRroomPropertyAction(
                    `?${byPrice}${locality ? locality : searchVal ? `&query=${'Lucknow'}` : `&query=${'Lucknow'}`
                    }${propertyType ? `&property_type=${propertyType}` : ""}${roomType ? `&room_type=${roomType}` : ""
                    }${choice}&page=${page}&limit=${itemsPerPage}`, page
                )
            ).finally(() => {
                isFetchingRef.current = false;
            });;
        } else {
            dispatch(
                getRroomPropertyAction(
                    `?order_direction=asc${locality ? locality : searchVal ? `&query=${'Lucknow'}` : `&query=${'Lucknow'}`
                    }&page=${page}&limit=${itemsPerPage}`, page
                )
            ).finally(() => {
                isFetchingRef.current = false;
            });;
        }
    }, [dispatch, sortValue, filterValues, page]);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [userDetail, page]);

    const getRoomCategory = async () => {
        try {
            const res = await services.property.getRoomCategoryService();
            if (res.status === 200) {
                setCategoryData(res?.data?.data);
            }
        } catch (error) { }
    };

    const getPropertyCategory = async () => {
        try {
            const res = await services.property.getPropertyCategoryService();
            if (res.status === 200) {
                setPropertyCategoryData(res?.data?.data);
            }
        } catch (error) { }
    };


    const filterCheckHAndler = (e, id) => {
        if (e.target.checked) {
            let getFilterValue = { ...filterValues };
            let mainObj = [...getFilterValue[e.target.name]];
            mainObj.push(id);
            getFilterValue[e.target.name] = mainObj;
            dispatch(setFilter({ [e.target.name]: mainObj }));
        } else {
            let getFilterValue = { ...filterValues };
            const resultfilter = getFilterValue[e.target.name].filter((d, index) => {
                return d !== id;
            });
            getFilterValue[e.target.name] = resultfilter;
            dispatch(setFilter({ [e.target.name]: resultfilter }));
        }
    };

    const getLocality = async (cityId) => {
        try {
            const res = await services.globalService.getLocalityByCity(cityId);
            if (res.status === 200) {
                setLocalities(res.data.data);
            }
        } catch (error) { }
    };


    const clearHandler = () => {
        dispatch(
            setFilter({
                propertyCategoryFilter: [],
                roomCategoryFilter: [],
                travellerChoice: [],
                localityFilter: [],
                latlongFilter: { lat: null, long: null },
            })
        );
        setSortValue("");
        dispatch(setSearch(""));
        dispatch(getRroomPropertyAction());
    };

    useEffect(() => {
        getRoomCategory();
        getPropertyCategory();
    }, []);

    const safeParse = (value) => {
        try {
            if (!value) return {};
            if (typeof value === "object") return value;
            if (typeof value === "string") return JSON.parse(value);
            return {};
        } catch (e) {
            console.error("Parse error:", value);
            return {};
        }
    };

    const ALL_SLOTS = ["3Hrs", "6Hrs", "9Hrs", "FullDay"];

    const mergeAllSlotsForDate = (statusData, priceData, date, slotRegularPrices) => {
        const statusSlots = statusData?.[date] || [];
        const priceSlots = priceData?.[date] || [];

        return ALL_SLOTS.map(slot => {
            const statusItem = statusSlots.find(s => s.slot === slot);
            const priceItem = priceSlots.find(p => p.slot === slot);

            // Fallback prices
            let fallbackPrice = null;
            switch (slot) {
                case "3Hrs":
                    fallbackPrice = slotRegularPrices?.threeHrPrice || 0;
                    break;
                case "6Hrs":
                    fallbackPrice = slotRegularPrices?.sixHrPrice || 0;
                    break;
                case "9Hrs":
                    fallbackPrice = slotRegularPrices?.nineHrPrice || 0;
                    break;
                case "FullDay":
                    fallbackPrice = slotRegularPrices?.regularPrice || 0;
                    break;
            }

            return {
                slot,
                status: statusItem ? statusItem.status : "Available",
                price: Number(priceItem?.price || fallbackPrice)
            };
        });
    };

    const goToDetailPage = (slot, slug) => {
        localStorage.setItem('slot', slot)
        navigate(`/hotels-in-lucknow/${slug}`)
    }

    const openFilters = () => {
        if (sidebarRef.current) {
            sidebarRef.current.classList.toggle('active');
        }
    };

    useEffect(() => {
        return () => {
            clearHandler()
        }
    }, [])

    return (
        <>
            <div className='inner-searchBar bg-gray section-sm'>
                <div className='container'>
                    <SearchBar />
                </div>
            </div>
            <div className='section-sm listing-page'>
                <div className='container'>
                    <div className='row'>
                        <div className='col-lg-3'>
                            <div className='sidebar' ref={sidebarRef}>
                                <div className='flex justify-content-between border-bottom p-2 pl-3'>
                                    <h4 className=''>Filter by</h4>
                                    <div className="right flex align-items-center">
                                        {
                                            !searchVal &&
                                                !sortValue &&
                                                filterValues?.propertyCategoryFilter?.length === 0 &&
                                                filterValues?.travellerChoice?.length === 0 &&
                                                filterValues?.localityFilter?.length == 0 &&
                                                filterValues?.roomCategoryFilter?.length === 0 ? null :
                                                <button
                                                    type='button'
                                                    className='btn-mat btn-mat-secondary btn-mat-sm'
                                                    onClick={clearHandler}>
                                                    Clear
                                                </button>
                                        }
                                        <span className="close ml-4" onClick={openFilters}><IoMdClose size={22} /></span>
                                    </div>
                                </div>
                                <div className='pl-2 pr-2'>
                                    <div className='box'>
                                        <h6 className='pb-2'>Traveller Choice</h6>
                                        <ul>
                                            {
                                                traveller?.map((data, key) => (
                                                    <li key={key}>
                                                        <label className='mark-field' htmlFor={`traveller${data.enum}`}>
                                                            <input
                                                                type="checkbox"
                                                                name="travellerChoice"
                                                                id={`traveller${data.enum}`}
                                                                onChange={(e) => filterCheckHAndler(e, data.enum)}
                                                                checked={filterValues?.travellerChoice?.includes(
                                                                    data.enum
                                                                )}
                                                            />
                                                            {data.name}
                                                            <span className='mark'></span>
                                                        </label>
                                                    </li>
                                                ))
                                            }
                                        </ul>
                                    </div>
                                    <div className='box'>
                                        <h6 className='pb-2'>Property By Category</h6>
                                        <ul>
                                            {
                                                propertyCategoryData?.map((data, key) => (
                                                    <li key={key}>
                                                        <label className='mark-field' htmlFor={`hotel${key}`}>
                                                            <input
                                                                type='checkbox'
                                                                id={`hotel${key}`}
                                                                name="propertyCategoryFilter"
                                                                checked={filterValues?.propertyCategoryFilter?.includes(
                                                                    data.id
                                                                )}
                                                                onChange={(e) => filterCheckHAndler(e, data.id)} />
                                                            {data.name}
                                                            <span className='mark'></span>
                                                        </label>
                                                    </li>
                                                ))
                                            }

                                        </ul>
                                    </div>
                                    <div className='box'>
                                        <h6 className='pb-2'>Rooms By Category</h6>
                                        <ul>
                                            {
                                                categoryData?.map((data, key) => (
                                                    <li key={key}>
                                                        <label className='mark-field' htmlFor={`room${key}`}>
                                                            <input
                                                                type='checkbox'
                                                                id={`room${key}`}
                                                                name="roomCategoryFilter"
                                                                checked={filterValues?.roomCategoryFilter?.includes(
                                                                    data.id
                                                                )}
                                                                onChange={(e) => filterCheckHAndler(e, data.id)} />
                                                            {data?.name && data.name.trim().toLowerCase().replace(/\b\w/g, c => c.toUpperCase())}
                                                            <span className='mark'></span>
                                                        </label>
                                                    </li>
                                                ))
                                            }
                                        </ul>
                                    </div>
                                    {
                                        localities?.length > 0 && (
                                            <div className='box'>
                                                <h6 className='pb-2'>Sort By Locality</h6>
                                                <ul>
                                                    {
                                                        localities?.map((data, key) => (
                                                            <li key={key}>
                                                                <label className='mark-field' htmlFor={`traveller${data.enum}`}>
                                                                    <input
                                                                        type="checkbox"
                                                                        name="localityFilter"
                                                                        id={`locality${data.id}`}
                                                                        checked={filterValues?.localityFilter == data.pin_code}
                                                                        onChange={() => {
                                                                            let temp =
                                                                                data.pin_code == filterValues.localityFilter
                                                                                    ? ""
                                                                                    : data.pin_code;
                                                                            dispatch(setFilter({ localityFilter: temp }));
                                                                        }}
                                                                    />
                                                                    {data.name}
                                                                    <span className='mark'></span>
                                                                </label>
                                                            </li>
                                                        ))
                                                    }
                                                </ul>
                                            </div>
                                        )
                                    }
                                </div>
                            </div>
                        </div>
                        <div className='col col-lg-9'>
                            <h4 className='text-white-sm pb-4'>
                                {
                                    loading ?
                                        "We are finding amazing hotels for you..." :
                                        <>
                                            <span className='fw-normal'>We found </span>
                                            {propertyCount}
                                            <span className='fw-normal'> amazing hotels for you</span>
                                        </>
                                }

                            </h4>
                            <span className="btn-filter" onClick={openFilters}><LuFilter size={18} className="mr-1" />Filters</span>
                            {
                                loading && <SklHotelCard />
                            }
                            {
                                rRoomProperty?.length > 0 &&
                                [...rRoomProperty].map((data, ind1) => {
                                    const profileImg = data?.PropertyImage?.length
                                        ? data?.PropertyImage.find(
                                            (i) => i.id === data?.profileImageID
                                        )
                                        : null;
                                    let allRating = 0;
                                    data?.Ratings?.map(
                                        (rating) => (allRating += rating?.rating)
                                    );
                                    const rateAverage =
                                        allRating / data?.Ratings?.length
                                            ? allRating / data?.Ratings?.length
                                            : 0;

                                    const imageList = data?.PropertyImages || [];
                                    if (profileImg) {
                                        imageList.unshift(profileImg);
                                    }
                                    const pet = data?.travellerChoice ? data?.travellerChoice.split(',').find((anm) => anm == 15) : []
                                    const PayAtHotel = data?.travellerChoice ? data?.travellerChoice.split(',').find((anm) => anm == 16) : []
                                    const imgCheck = data?.PropertyImages?.find((img) => img?.id == data?.profileImageID)
                                    const primaryImg = imgCheck ? imgCheck?.image : data?.PropertyImages?.find((img) => img?.title == 'Facade')?.image
                                    const slug = data?.slug?.replace(/^\//, '')
                                    const today = moment();
                                    let xPrice = []
                                    let mPrice = 0
                                    data?.Rooms.forEach((item) => {
                                        const fromDate = moment(item?.fromDate);
                                        const toDate = moment(item?.toDate);

                                        const isTodayInRange =
                                            today.isSameOrAfter(fromDate, "day") &&
                                            today.isSameOrBefore(toDate, "day");

                                        xPrice.push(isTodayInRange ? item?.offerPrice : item?.regularPrice);
                                        mPrice = Math.min(...xPrice);
                                    });

                                    let checkToday = moment(new Date()).format('YYYY-MM-DD')
                                    let threeHrStatus = safeParse(data?.Rooms.find((room) => room?.categoryId == 1)?.threeHrStatus)
                                    let threeHrOfferPrice = safeParse(data?.Rooms.find((room) => room?.categoryId == 1)?.threeHrOfferPrice ?? data?.Rooms.find((room) => room?.categoryId != 1)?.offerPrice)
                                    let slotRegularPrices = data?.Rooms.find((room) => room?.categoryId == 1) ?? data?.Rooms.find((room) => room?.categoryId != 1)

                                    const newData = {
                                        [checkToday]: mergeAllSlotsForDate(threeHrStatus, threeHrOfferPrice, checkToday, slotRegularPrices)
                                    };


                                    let fullDayPrice = newData[checkToday].find((it) => it?.slot == "FullDay")?.price

                                    if (data.id == 44) {
                                        // console.log(data.name, primaryImg)
                                    }

                                    return (
                                        <Link to={`/hotels-in-lucknow/${slug}`} className='hotel-card' key={ind1}>
                                            <div className='img'>
                                                {
                                                    primaryImg ? (
                                                        <CommonSlider settings={{ slidesToShow: 1, arrows: false }}>
                                                            {
                                                                imageList?.map((img, ind2) => {
                                                                    return (
                                                                        <img
                                                                            key={ind2}
                                                                            src={
                                                                                `${baseImgUrl}${primaryImg}`
                                                                            }
                                                                            className='d-block rounded-1' title='' alt='' />
                                                                    )
                                                                })
                                                            }
                                                        </CommonSlider>
                                                    ) : <img src={`${ImagesData?.ImgNoImage}`} title="" alt="" />
                                                }

                                                <span
                                                    className={`btn btn-secondary btn-sm`}
                                                    style={{ backgroundColor: PROPERTY_CATEGORY_COLORS[data?.PropertyCategory?.id] }}>
                                                    {data?.PropertyCategory?.name}
                                                </span>
                                            </div>
                                            <div className='text'>
                                                <h4 className='pb-1'>
                                                    {capitalizeEachWord(data?.name ?? "N/A")}
                                                </h4>
                                                {
                                                    data?.locality &&
                                                    <p className='v-center text-secondary'>
                                                        <IoLocationOutline size={18} className='mr-1' />
                                                        {data?.locality}
                                                        {`, ${data?.city?.name}`}
                                                        {
                                                            data?.distance &&
                                                            <span className="btn-mat btn-mat-success btn-mat-sm ml-2">
                                                                {
                                                                    data?.distance && data?.distance?.toFixed(2) + " km"
                                                                }
                                                            </span>
                                                        }
                                                    </p>
                                                }
                                                <div className='flex text-gray amenties pt-2 pb-3'>
                                                    {
                                                        data?.PropertyAmenities?.length > 0 ?
                                                            data?.PropertyAmenities?.slice(0, 3)?.map((amen, ind3) => {
                                                                return (
                                                                    <span className='v-center white-space-nowrap fs-6 mr-4' key={ind3}>
                                                                        <img
                                                                            loading="lazy"
                                                                            src={
                                                                                `${baseImgUrl}` +
                                                                                amen?.Amenity?.icon
                                                                            }
                                                                            className='wpx-4 mr-2' title="" alt=""
                                                                        />
                                                                        {amen?.Amenity?.name}
                                                                    </span>
                                                                )
                                                            }) : ''
                                                    }
                                                    <span className='btn-link'>+ 4 more</span>
                                                </div>
                                                <div className='flex align-items-center travel-options'>
                                                    {
                                                        data?.coupleFriendly == 1 &&
                                                        <span className='btn-mat btn-mat-default rounded-1 mr-2'>Couple Friendly</span>
                                                    }
                                                    {
                                                        data?.locaidAccept == 1 &&
                                                        <span className='btn-mat btn-mat-default rounded-1 mr-2'>Local ID Accepted</span>
                                                    }
                                                    {
                                                        pet &&
                                                        <span className='btn-mat btn-mat-default rounded-1 mr-2'>Pet Friendly</span>
                                                    }
                                                    {
                                                        PayAtHotel &&
                                                        <span className='btn-mat btn-mat-default rounded-1'>Pay at Hotel</span>
                                                    }
                                                </div>
                                                {
                                                    data?.allowHourly ? (
                                                        <div className='flex align-items-center hourly mt-3'>
                                                            {
                                                                newData[checkToday]?.slice(0, 3)?.map((item, i) => {
                                                                    return (
                                                                        <button
                                                                            key={i}
                                                                            type="button"
                                                                            className="btn btn-info btn-block mr-2"
                                                                            disabled={item.status == "Sold-Out" || item?.price == 0}
                                                                            onClick={() => goToDetailPage('hourly', slug)}
                                                                        >
                                                                            {
                                                                                item?.price == 0 && <span className="d-block fs-6 mb-1">Not Available</span>
                                                                            }
                                                                            {
                                                                                item?.price > 0 && <span className="d-block fs-4">₹{item?.price}</span>
                                                                            }
                                                                            <span>{item?.slot?.replace(/(\d+)(Hrs)/, '$1 $2')}</span>
                                                                            {item.status == "Sold-Out" && <span className="text-danger"> - Sold-Out</span>}
                                                                        </button>
                                                                    )
                                                                })
                                                            }
                                                        </div>
                                                    ) : null
                                                }
                                            </div>
                                            <div className='details text-right rounded-2'>
                                                <div className='top'>

                                                    <div className='btn-mat btn-mat-secondary pl-10'>
                                                        <span className='bg-secondary text-white fs-8 rounded-4'>
                                                            {rateAverage.toFixed(1)}/5
                                                        </span>{" "}
                                                        {rateAverage >= 5
                                                            ? "Excellent "
                                                            : rateAverage >= 4
                                                                ? "Very Good"
                                                                : rateAverage >= 3
                                                                    ? "Good"
                                                                    : "Good"}
                                                    </div>

                                                    <p className='fs-8 pt-1 pb-1'>({data?.Ratings?.length} Ratings)</p>
                                                    <h4 className='fw-normal'>
                                                        <span className='d-block fs-7'>

                                                            <span className="d-block">
                                                                <span className="text-line-through text-danger fw-bold">
                                                                    ₹{Math.round((fullDayPrice ?? 0) * 20 / 100 + (fullDayPrice ?? 0))}
                                                                </span>{" "}
                                                                20% Off
                                                            </span>

                                                        </span>
                                                        <span className='fw-bold d-block'>
                                                            ₹{
                                                                fullDayPrice
                                                            }
                                                        </span>
                                                        <span className='fs-7'>Per Night</span>

                                                    </h4>
                                                </div>
                                                <span onClick={() => goToDetailPage('fullDay', slug)} className='btn btn-primary btn-block btn-lg'>Full Day</span>
                                            </div>
                                        </Link>
                                    )
                                })
                            }
                            {
                                !loading && rRoomProperty.length === 0 &&
                                <div className="no-data">
                                    <img src={ImagesData?.ImgNoData?.src} title="" alt="" />
                                    <h3>Oops! We couldn’t find any hotels. </h3>
                                    <Link to="/" className="btn btn-primary btn-sm">Homepage</Link>
                                </div>
                            }

                            {
                                propertyCount > itemsPerPage ?
                                    <ReactPaginate
                                        previousLabel={"←"}
                                        nextLabel={"→"}
                                        pageCount={totalPages}
                                        onPageChange={(e) => setPage(e.selected + 1)}
                                        containerClassName="pagination"
                                        activeClassName="active"
                                        className="pagination"
                                    /> : ''
                            }

                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default HotelsInLucknow